import React from "react";
import "./styles.scss";
import { MdClose } from "react-icons/md";
import { Country } from "../../../../../shared/constants/Constant";

interface IProps {
  country: Country;
  onClose(country: Country): void;
}

const CountryTag = (props: IProps) => {
  return (
    <div className="country-tag">
      <div>{props.country.replace("_", " ")}</div>
      <div>
        <MdClose
          onClick={() => {
            props.onClose(props.country);
          }}
        />
      </div>
    </div>
  );
};

export default CountryTag;
